import styled, { css } from 'styled-components'

import { omitProps } from '../omitProps'

const fillStyle = css`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
`

export const transitionTime = 0.3

type Props = {
	isAnimated?: boolean
	fill?: boolean
}

export const Container = styled.div.withConfig({ shouldForwardProp: omitProps('fill', 'isAnimated') })<Props>`
	transition: ${({ isAnimated }) => (isAnimated ? `height ${transitionTime}s` : 'none')};
	overflow: hidden;

	${({ fill }) => (fill ? fillStyle : undefined)};
`
